import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Aos from 'aos';
import './aos.css';

function GridExample() {
  const cardData = [
     {
      title: "Mission Statement",
      text: "ACE International Academy offers Cambridge International Examinations CIEs / University of Cambridge Local Examinations Syndicate (UCLES) curricula that enables its multi-ethnic students to achieve their optimum intellectual, social, emotional and physical potential; encouraging in them respect for others, benevolence and good manners.",
      image: "/images/missionstatement.jpg",
          bgColor: "#dc7633", // dark gray
    },
    {
      title: "Admission",
      text: "There is no admission test for students in grades lower than KG 1 but for all other grades admission is granted based on the results of the admission tests for English, Science and Mathematics. An interview for potential students with the Head of the section is compulsory. Placement will depend on their recommendation and positive academic report of previous school attended.",
      image: "/images/admission.jpg",
          bgColor: "#f4d03f", // dark gray
    },
    {
      title: "Academics Libraries",
      text: "The chief objective of the Academy is to provide quality education of an international standard to students of various nationalities. The harmonious co-existence of these students enables the Academy to promote effective international awareness by providing them with opportunities to mutually share universally valid ideas, cultural norms, traditions, beliefs and customs. that each individual may bring, and develop a sense of unity among them. The ACE libraries have fully automated system. All transactions are handled electronically",
      image: "/images/academics.jpg",
          bgColor: "#a569bd", // dark gray
    },
   
  ];

  const [expandedCards, setExpandedCards] = useState({});

  const toggleExpand = (index) => {
    setExpandedCards((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const getTrimmedText = (text, index) => {
    const words = text.split(' ');
    const isExpanded = expandedCards[index];
    if (isExpanded || words.length <= 20) return text;
    return words.slice(0, 20).join(' ') + '...';
  };

useEffect(() => {
    Aos.init({});
  }, [])

  return (
    <Row xs={1} md={3} className="g-3 p-3">
  {cardData.map((item, idx) => (
    <Col key={idx} className="d-flex">
      <Card
        className="text-center p-3 shadow-sm h-100 d-flex flex-column justify-content-between"
        style={{ backgroundColor: item.bgColor }}


        // style={{
        //   border: '1px solid #ddd',
        //   borderRadius: '10px',
        //   backgroundColor: '#ffffff',
        //   boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
        // }}
      >
        <div data-aos="flip-left" data-aos-duration="2500">
        <Card.Img
          variant="top"
          src={item.image}
          alt={item.title}
          style={{
            width: '400px',
            height: '200px',
            objectFit: 'cover',
            margin: '0px auto',
            borderRadius: '5px',
          }}
        />
      </div>
        <Card.Body className="d-flex flex-column">
          <Card.Title>{item.title}</Card.Title>
          <Card.Text style={{ textAlign: 'justify' }}>
            {getTrimmedText(item.text, idx)}
          </Card.Text>
          {item.text.split(' ').length > 10 && (
            <span
              onClick={() => toggleExpand(idx)}
              className="mt-auto"
              style={{
                color: '#000000',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
            >
              {expandedCards[idx] ? 'Read less' : 'Read more'}
            </span>
          )}
        </Card.Body>
      </Card>
    </Col>
  ))}
</Row>

  );
}

export default GridExample;
